import type { SurfaceChatContext } from '../contexts/SurfaceContext';

function readString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

/**
 * Resolve default artifact_item ref from surface context metadata
 * (publishers set `artifactItemRef` or `artifact_item_ref`).
 */
export function resolveSurfaceArtifactItemRef(
  context: Pick<SurfaceChatContext, 'metadata'> | null | undefined
): string | undefined {
  const metadata = context?.metadata;
  if (!metadata || typeof metadata !== 'object') return undefined;
  return (
    readString(metadata.artifactItemRef) ??
    readString(metadata.artifact_item_ref) ??
    readString(metadata.selectedArtifactItemId)
  );
}
